module.exports = __webpack_public_path__ + "static/media/CD.ebd0b9b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CD.svg
// module id = 219
// module chunks = 0